import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * Muestra un botón "Instalar app" flotante cuando el navegador (Chrome/Android
 * o Edge/Desktop) dispara el evento beforeinstallprompt. En iOS Safari no se
 * dispara — allí se instala manualmente vía Compartir → Agregar a inicio.
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(
    typeof window !== "undefined" && localStorage.getItem("pwa_install_dismissed") === "1"
  );

  useEffect(() => {
    const onBefore = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setDeferred(null);
      localStorage.setItem("pwa_install_dismissed", "1");
    };
    window.addEventListener("beforeinstallprompt", onBefore);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBefore);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferred || dismissed) return null;

  const install = async () => {
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome === "accepted") {
      localStorage.setItem("pwa_install_dismissed", "1");
    }
    setDeferred(null);
  };

  const close = () => {
    localStorage.setItem("pwa_install_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-50 rounded-2xl bg-white border border-neutral-200 shadow-xl p-4 flex items-start gap-3 animate-in slide-in-from-bottom-4"
    >
      <img src="/logo-mark.png" alt="" className="w-10 h-10 object-contain shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold text-neutral-900">Instalá la app</div>
        <p className="text-xs text-neutral-500 mt-0.5 mb-3">
          Agregá Clara Martínez a tu pantalla de inicio para acceder más rápido.
        </p>
        <button
          data-testid="pwa-install-btn"
          onClick={install}
          className="btn-primary-pill text-sm py-2 px-4"
        >
          <Download className="w-4 h-4 mr-1.5" /> Instalar
        </button>
      </div>
      <button
        data-testid="pwa-install-close"
        onClick={close}
        className="text-neutral-400 hover:text-neutral-700 transition-colors shrink-0"
        aria-label="Cerrar"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
